import { render, staticRenderFns } from "./DublicatedLeads.vue?vue&type=template&id=349c5e5a"
import script from "./DublicatedLeads.vue?vue&type=script&lang=js"
export * from "./DublicatedLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports